import { useEffect, useState } from 'react';

/**
 * True when the viewport is narrower than `breakpoint` (default 768px).
 * Drives the hard split between the dedicated MobileApp and the desktop app.
 */
export function useIsMobile(breakpoint = 768) {
  const read = () => (typeof window !== 'undefined' ? window.innerWidth < breakpoint : false);
  const [isMobile, setIsMobile] = useState(read);
  useEffect(() => {
    const onResize = () => setIsMobile(read());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breakpoint]);
  return isMobile;
}

export default useIsMobile;
